import React, { useEffect } from 'react'

const Careers = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div>
      <div className="bg-white py-32">

        <div className="mx-auto  px-6 lg:px-8">
          <div className="mx-auto  lg:mx-0">
            <h2 className="text-lg  font-semibold text-mblack ">CAREERS</h2>
            <p className=" lg:text-4xl text-2xl  mt-5 font-mfont font-bold text-mblack leading-8 ">
              Join Our Team at Making Minds Technologies.
            </p>
            <p className=" lg:text-2xl text-2xl  mt-5 font-mfont text-mblack leading-8 ">At Making Minds Technologies, we believe in the power of
              innovation, creativity, and collaboration. As a leading website development company, we are on a mission to create digital
              experiences that not only meet but exceed our clients' expectations. If you are passionate about pushing the boundaries of
              web development and eager to work in a dynamic and inspiring environment, we want you on our team.</p>
          </div>
        </div>

        <section className="dark:bg-dark  lg:pt-[30px] m-5 lg:m-10">
          <div className="container mx-auto">
            <div className="-mx-4 flex flex-wrap">
              <div className="w-full px-4">
                <div className="mx-auto mb-5 text-center ">
                  <h2 className="mb-3 text-3xl font-bold font-mfont leading-[1.2] text-dark dark:text-white sm:text-4xl md:text-[40px]">
                    Why Choose Making Minds Technologies?
                  </h2>
                </div>
              </div>
            </div>

            <div className="-mx-4 flex flex-wrap mt-10">
              <ServiceCard
                title=" Cutting-edge Projects"
                details="Join a team that works on diverse and challenging projects, from e-commerce solutions to custom web applications. At Making Minds Technologies, you'll have the opportunity to contribute to groundbreaking digital experiences that make a real impact."
                icon={
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 512 512" version="1.1">
                    <title>project-new</title>
                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g id="Combined-Shape" fill="#000000" transform="translate(64.000000, 34.346667)">
                        <path d="M192,-7.10542736e-15 L384,110.851252 L384,242.986 L341.333,242.986 L341.333,157.655 L213.333,231.555 L213.333,431.088 L192,443.405007 L0,332.553755 L0,110.851252 L192,-7.10542736e-15 Z M341.333333,264.32 L341.333,328.32 L405.333333,328.32 L405.333333,370.986667 L341.333,370.986 L341.333333,434.986667 L298.666667,434.986667 L298.666,370.986 L234.666667,370.986667 L234.666667,328.32 L298.666,328.32 L298.666667,264.32 L341.333333,264.32 Z M42.666,157.654 L42.6666667,307.920144 L170.666,381.82 L170.666,231.555 L42.666,157.654 Z M192,49.267223 L66.1333333,121.936377 L192,194.605531 L317.866667,121.936377 L192,49.267223 Z">

                        </path>
                      </g>
                    </g>
                  </svg>
                }
              />
              <ServiceCard
                title=" Collaborative Culture"
                details="We foster a culture of collaboration, where every team member's ideas are valued. Our open and inclusive work environment encourages creativity and innovation, ensuring that your voice is heard and your talents are recognized."
                icon={
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" id="Layer_1" data-name="Layer 1"><defs><style></style></defs><circle className="cls-1" cx="12" cy="3.41" r="1.91" /><path className="cls-1" d="M9.14,8.18h0A2.86,2.86,0,0,1,12,5.32h0a2.86,2.86,0,0,1,2.86,2.86h0" /><circle className="cls-1" cx="19.64" cy="14.86" r="1.91" /><path className="cls-1" d="M16.77,19.64h0a2.86,2.86,0,0,1,2.87-2.87h0a2.86,2.86,0,0,1,2.86,2.87h0" /><circle className="cls-1" cx="4.36" cy="14.86" r="1.91" /><path className="cls-1" d="M1.5,19.64h0a2.86,2.86,0,0,1,2.86-2.87h0a2.86,2.86,0,0,1,2.87,2.87h0" /><path className="cls-1" d="M2.47,11.37A9.53,9.53,0,0,1,7.38,3.65" /><path className="cls-1" d="M16.62,3.65a9.53,9.53,0,0,1,4.91,7.72" /><path className="cls-1" d="M8.39,21.79a9.53,9.53,0,0,0,7.22,0" /></svg>
                }
              />
              <ServiceCard
                title="Continuous Learning"
                details="In the ever-evolving world of web development, staying ahead is crucial. We provide opportunities for continuous learning and professional development, ensuring that you grow alongside the latest technologies and industry trends.                "
                icon={
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 1024 1024" fill="#000000" className="icon" version="1.1"><path d="M890.378 185.931v-87.011l-394.703 87.011h-33.281l-394.703-87.011v87.011h-41.486v695.564h431.986v0.957l4.205-0.957h33.281l4.205 0.957v-0.957h497.918v-695.564h-107.421zM109.383 185.931v-35.199l348.804 76.934v603.011l-348.804-76.973v-567.774zM848.722 150.654v602.969l-348.844 76.934v-602.969l348.844-76.934zM961.559 558.27h-48.986v-49.111h48.986v49.111zM88.513 831.553v-39.819l180.482 39.819h-180.482zM876.463 790.151v41.319h-187.354l187.354-41.319zM411.698 339.134l-258.582-86.096 5.747-17.164 7.497-22.368 258.582 86.096-13.247 39.529zM411.698 450.802l-258.582-86.096 13.164-39.529 258.582 86.096-13.164 39.529zM411.698 562.518l-258.582-86.096 13.164-39.529 258.582 86.096-13.164 39.529zM411.698 674.106l-258.582-86.055 13.164-39.529 258.582 86.055-13.164 39.529zM411.698 772.951l-258.582-86.055 13.164-39.529 258.582 86.055-13.164 39.529zM546.405 339.134l-13.164-39.529 258.54-86.096 7.497 22.368 5.79 17.164-258.666 86.096zM546.405 450.802l-13.164-39.529 258.54-86.096 13.164 39.529-258.54 86.096zM546.405 562.518l-13.164-39.529 258.54-86.096 13.164 39.529-258.54 86.096zM546.405 674.106l-13.164-39.529 258.54-86.055 13.164 39.529-258.54 86.055zM546.405 772.951l-13.164-39.529 258.54-86.055 13.164 39.529-258.54 86.055z" /></svg>

                }
              />
              <ServiceCard
                title="Work-Life Balance"
                details="We understand the importance of a healthy work-life balance. At Making Minds Technologies,
                 we prioritize our team members' well-being, offering flexible work schedules and remote
                  work options and it is essential for well-being and satisfaction. "
                icon={
                  <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" version="1.1" id="Layer_1" width="36" height="36" viewBox="0 0 256 173" enable-background="new 0 0 256 173" >
                    <path d="M128.253,56.864c15.186,0,27.432-12.247,27.432-27.432S143.536,2,128.253,2  c-15.186,0-27.432,12.247-27.432,27.432C100.918,44.716,113.165,56.864,128.253,56.864z M64.571,136.32h-49.28  c-15.969,0-16.851-24.395,0.294-24.395H58.3l24.493-36.054c7.25-9.895,15.48-14.598,27.138-14.598h36.544  c11.659,0,19.888,4.311,27.138,14.598l24.591,36.054h43.01c17.243,0,16.165,24.395,0.588,24.395h-49.28  c-3.919,0-8.622-1.372-11.365-5.584l-18.811-26.844l-0.098,67.209H94.844l-0.098-67.209l-18.811,26.844  C73.192,134.85,68.49,136.32,64.571,136.32z" />
                    <path d="M223.729,103.771C240.387,103.771,254,90.248,254,73.5s-13.524-30.271-30.271-30.271  s-30.182,13.613-30.182,30.361C193.547,90.248,207.07,103.771,223.729,103.771z M222.057,76.067  c-5.553-1.94-9.016-4.747-9.016-9.732c0-4.597,3.045-8.21,8.628-9.344v-4.986h4.179v4.747c3.463,0,5.971,0.716,7.822,1.702  l-1.702,5.971c-1.373-0.567-3.612-1.523-6.687-1.523c-3.075,0-4.747,1.523-4.747,3.045c0,2.09,1.94,2.896,6.12,4.597  c5.702,2.09,8.359,4.986,8.359,9.732s-2.896,8.359-9.016,9.732v4.747h-4.179v-4.597c-3.612,0-7.254-0.955-9.016-1.94l1.523-6.12  c1.94,0.955,4.986,2.09,8.21,2.09c3.463,0,5.165-1.523,5.165-3.612S226.057,77.62,222.057,76.067z" />
                    <path d="M54.468,75.815c6.637-5.836,7.464-16.004,1.603-22.766l0,0c-5.836-6.637-16.004-7.464-22.766-1.603L31,53.45  l-2.304-2.004c-6.637-5.836-16.931-5.034-22.766,1.603l0,0C0.069,59.711,0.895,69.98,7.532,75.815l23.092,23.668L54.468,75.815z" />
                    <g id="shopping_cart">
                    </g>
                    <g id="cross">
                    </g>
                    <g id="leaf">
                    </g>
                  </svg>
                }
              />

            </div>
          </div>
        </section>

        <div className="container m-auto px-6 ">
          <div className="text-center text-2xl">
            <h2 className="mb-3 text-3xl font-bold font-mfont leading-[1.2] text-dark dark:text-white sm:text-4xl md:text-[40px]">Job Opportunities.</h2>
            <p className="text-center text-2xl font-bold font-mfont mt-5  text-black mb-5">Join us in shaping the future of Development.
            </p>
          </div>

          <div className="-mx-4 flex flex-wrap mt-0">
            <JobCard
              jobtitle=" Web Developer"
              jobdetails="Experience with front-end and back-end technologies.
                Strong knowledge of HTML, CSS, JavaScript, and relevant frameworks.
                Proven track record of delivering high-quality web solutions."
              link="mailto: talentmakingminds@outlook.in"
            />
            <JobCard
              jobtitle="UX/UI Designer"
              jobdetails="Proficiency in design tools like Adobe XD, Sketch, or Figma.
              Strong understanding of user-centered design principles.
              Portfolio showcasing innovative and visually appealing designs."
              link="mailto: talentmakingminds@outlook.in"
            />
            <JobCard
              jobtitle="Digital Marketer"
              jobdetails="Develop and execute comprehensive digital marketing strategies to 
              achieve business goals, utilizing channels such as social media, E-mail, search engine optimization, and PPC."
              link="https://forms.gle/kGsQsonPvnKgRQS26"
            />
            <JobCard
              jobtitle="Customer Service Executive"
              jobdetails="Lead and manage a team of agents, communicate customer needs to
               stakeholders, and understand exactly how customers use your product or service."
               link="mailto: talentmakingminds@outlook.in"
            />
          </div>
        </div>

      </div>

      <div className="container m-auto px-6 mb-10 -mt-10 ">
        <div className="flex flex-col md:flex-row items-center justify-between relative w-100 h-auto md:h-64 bg-mcolor rounded-lg p-8">
          <div className=" text-2xl">
            <span className=' flex text-4xl font-mfont text-white mb-4'>Ready to take your career to the next level ?</span>
            <p className="font-mfont text-mwhite text-sm text-left">Send your resume, portfolio, or a cover letter detailing why you're the perfect fit for joining Making Minds Technologies Team.</p>
          </div>
          <div className="relative shadow-md font-medium my-5 py-2 px-4 mt-6 text-black cursor-pointer bg-white hover:bg-gray-300 rounded text-lg text-center w-48">
            <a
              href="mailto: talentmakingminds@outlook.in"
              target='_blank'
              rel="noreferrer"
            > Drop a Email </a>
          </div>
        </div>
      </div>




    </div>
  )
}

export default Careers

const ServiceCard = ({ icon, title, details }) => {
  return (
    <>
      <div className="w-full px-4 md:w-1/2 lg:w-1/4">
        <div className="mb-9 rounded-[20px] bg-mcolor p-10 shadow-2 hover:shadow-lg dark:bg-dark-2 md:px-7 xl:px-10">
          <div className="mb-8 flex h-[70px] w-[70px] items-center justify-center rounded-2xl bg-blue-200">
            {icon}
          </div>
          <h4 className="mb-[14px] font-mfont text-2xl font-semibold text-white dark:text-white">
            {title}
          </h4>
          <p className="text-body-color font-semibold text-white font-mfont dark:text-dark-6">{details}</p>
        </div>
      </div>
    </>
  );
};

const JobCard = ({ jobtitle, jobdetails, link }) => {
  return (
    <div>
      <div className="flex flex-col bg-white shadow-lg mx-2 my-5 p-6 rounded-lg border-l-4  border-mcolor border sm:flex-row sm:mx-8 sm:my-4">
        <div className="flex flex-col justify-evenly ml-4">
          <h4 className="mb-[14px] font-mfont text-2xl font-semibold text-black dark:text-white">
            {jobtitle}
          </h4>
          <p className=" font-semibold text-black font-mfont dark:text-dark-6 p-1">{jobdetails}</p>
        </div>
        <div className="flex flex-wrap items-center my-1 mx-2 pt-4 ">
          <a href={link} target='_blank' rel="noreferrer" className="text-md hover:bg-gray-600 mr-2 mb-2 p-2.5 rounded-lg font-bold font-mfont text-white bg-mcolor" >
            Apply
          </a>
        </div>
      </div>

    </div >
  )
}